import { Palette } from 'core/config';
import styled from 'styled-components';

export const InfoTextArea = styled.textarea`
    color: ${Palette.BLUE};
    font-family: SofiaPro-Regular;
    font-size: 14px;
    padding: 0.5rem;
    border: 1px solid ${Palette.BLUE};
    border-radius: 0.5rem;
    resize: none;
`;
